import { Link } from "react-router-dom";

export default function PublicFooter() {
  return (
    <footer className="mp-public-footer">
      <Link to="/">MinutePay</Link>
      <span aria-hidden="true">·</span>
      <Link to="/terms">Terms</Link>
      <span aria-hidden="true">·</span>
      <Link to="/privacy">Privacy</Link>
      <span aria-hidden="true">·</span>
      <Link to="/refunds">Refund Policy</Link>
    </footer>
  );
}
